import { render, staticRenderFns } from "./layout-image-orange-with-number.vue?vue&type=template&id=68873b01&scoped=true&"
import script from "./layout-image-orange-with-number.vue?vue&type=script&lang=js&"
export * from "./layout-image-orange-with-number.vue?vue&type=script&lang=js&"
import style0 from "./layout-image-orange-with-number.vue?vue&type=style&index=0&id=68873b01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68873b01",
  null
  
)

export default component.exports